import React from 'react';

function SearchingFilesContent() {
  return (
    <>
      <p>The search function in RepoPrompt helps you quickly locate specific files in large workspaces.</p>
      
      <h3>Basic Search</h3>
      <ol>
        <li>Locate the "Search files" input box above the file tree panel</li>
        <li>Type your search query (e.g., a file name or part of it)</li>
        <li>The file tree will dynamically filter to show only matching files and their parent folders</li>
        <li>Clear the search box to restore the full file tree view</li>
      </ol>
      
      <h3>Advanced Search Patterns</h3>
      <p>RepoPrompt supports pattern-based searching:</p>
      <ul>
        <li><strong>Wildcards:</strong> Use <code>*</code> to match any sequence of characters
          <ul>
            <li>Example: <code>*.css</code> shows only CSS files</li>
            <li>Example: <code>*.test.*</code> might find test files with any extension</li>
          </ul>
        </li>
        <li><strong>Basic Regex:</strong> Use regular expression patterns for more complex searches</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> Combine searching with filtering to quickly isolate the specific files you need for your prompt context.
      </div>
    </>
  );
}

export default SearchingFilesContent;